import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { pages } from '../nav-items';
import InvoicesPage from './invoices-page';
import ArchivePage from './archive-page';
import StampsAccountDecisionPage from './sections/cancellation/stamps/stamps-account-decision-page';
import { WalletDataContextProvider } from '../../../wallet/contexts/wallet-data-context-provider';
import PaymentAndSubscriptionPageContextProvider from './context/payment-and-subscription-page-context';
import { PaymentAndSubscriptionPageContent } from './page/content';

export const PaymentAndSubscriptionPage = () => {
  return (
    <PaymentAndSubscriptionPageContextProvider>
      <WalletDataContextProvider>
        <PaymentAndSubscriptionPageContent />
      </WalletDataContextProvider>
    </PaymentAndSubscriptionPageContextProvider>
  );
};

const paymentsAndSubscriptionRoute = `/${pages.settings.location}/${pages.paymentAndSubscription.location}`;

export const PaymentAndSubscriptionRouter = () => {
  return (
    <Switch>
      <Route component={InvoicesPage} path={`${paymentsAndSubscriptionRoute}/${pages.invoices.location}`} />
      <Route component={ArchivePage} path={`${paymentsAndSubscriptionRoute}/${pages.archive.location}`} />
      <Route component={StampsAccountDecisionPage} path={`${paymentsAndSubscriptionRoute}/${pages.cancelStamps.location}`} />
      <Route component={PaymentAndSubscriptionPage} path={`${paymentsAndSubscriptionRoute}`} />
    </Switch>
  );
};
